import { queryOptions, useMutation } from '@tanstack/react-query';
import { axiosGet, axiosPost } from '../utils/api';

export const getMe = ({ accessToken = localStorage.getItem('authToken'), params }) =>
  queryOptions({
    queryKey: ['/auth/me', params],
    queryFn: async () => {
      const res = await axiosGet('/auth/me', { params }, accessToken);
      return res.data;
    },
    enabled: !!accessToken,
  });

export const useLogin = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/auth/login', data);
    },
  });

export const useCheckUser = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/auth/check-user', data);
    },
  });

export const useRegister = () =>
  useMutation({
    mutationFn: ({ data }) => {
      return axiosPost('/auth/register', data);
    },
  });
